/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TimeClockMoveForwardIcon20Solid = forwardRef('TimeClockMoveForwardIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M8.225 4.009A6.249 6.249 0 0 1 14.8 6H14a1 1 0 1 0 0 2h3a1 1 0 0 0 1-1V4a1 1 0 1 0-2 0v.34a8.248 8.248 0 1 0 1.536 9.015 1 1 0 1 0-1.828-.814A6.248 6.248 0 1 1 8.226 4.01Z" }),
        React.createElement("path", { d: "M10.73 6.443a1 1 0 1 0-2 0v3.123a2.25 2.25 0 0 0 1.22 2.001l2.693 1.384a1 1 0 0 0 .914-1.779L10.865 9.79a.25.25 0 0 1-.136-.223V6.443Z" })));
});
